import React, { Component } from 'react';
import { Button } from 'reactstrap';
import Slider from 'react-slick';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
import language from '../../../../assets/languages/language';
import Loader from '../../../../common/loader';
import CBTFinishTest from '../../../Common/CBTFinishTest';
import CBTNonAttempted from '../../../Common/CBTNonAttempted';
import CBTFlagged from '../../../Common/CBTFlagged';
import AppRoutes from '../../../config/AppRoutes';
import 'sweetalert2/dist/sweetalert2.css';
import { questionsettings } from '../../../../common/cbtleftnavigationsettings';
import { caseCV } from '../../../../common/cbttopnavigationsettings';

import { highlightString, clearSelection } from '../../../../common/highlightText';
import { optionsArr, SecondsToHHMMSS } from '../../../../common/constant';
let attemptedCaseArray = [];
/* eslint-disable*/
const longPressDuration = 450;
class CFAQuestions extends Component {
  selectionShare;
  constructor(props) {
    super(props);
    this.state = {
      questionsData: [],
      isLoading: true,
      isDataLoading: true,
      token: '',
      idname: '',
      userStatsData: '',
      time: {},
      seconds: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
      showFinishTestPopup: false,
      mockName: '',
      flag: [],
      showSectionReview: false,
      showAttempted: false,
      showUnattempted: false,
      showFlagged: false,
      filter: [],
      showNonAttemptedPopup: false,
      showFlaggedPopup: false,
      selectedQuestionData: [],
      runDecrement: true,
      isNegative: false,
      timerStart: this.props.params.timerStart,
      selectedQuestion: '',
      highlights: [],
      showPopover: false,
      strikeThroughArr: [],
      vpCaseLoader: true,
      questionLoader: true,
      readingViseScore: '',
      report_block: 'card hide_block',
      totalQuestionCount: 0,
    };
    this.longPressCountdown = null;
    this.timer = 0;
    this.countDown = this.countDown.bind(this);
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidUpdate = (prevProps) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (
      prevProps.params.caseOffset !== this.props.params.caseOffset ||
      prevProps.params.quesOffset !== this.props.params.quesOffset
    ) {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      };
      this.getCases(data);
      this.getUserStats();
      this.getFlagQuestions();
    }
  };

  getFlagQuestions = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getflaggedQuestions', data).then(
      async (res) => {
        if (res) {
          this.setState({ flag: res.data });
        }
      },
    );
  };

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
    };
    this.getCases(data);
    this.getUserStats();
    this.getrightanswer();
    // this.getFlagQuestions();
    if (this.props.params.timerStart === 'true') {
      this.timer = setInterval(this.countDown, 1000);
    } else {
      clearInterval(this.timer);
    }
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getMockNamebyId', data).then(
      async (res) => {
        this.setState({
          mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
        });
      },
    );
  };

  getDetailedResultGraph = (totalQuestion) => {
    const { id, testid, timer } = this.props.params;
    let path = AppRoutes.CFA2_DETAILED_RESULT_GRAPH.replace(':id', id)
      .replace(':test_id', testid)
      .replace(':totalQuestions', totalQuestion)
      .replace(':timer', timer)
      .replace(':isNegative', this.state.isNegative);
    this.context.router.push({
      pathname: path,
    });
  };

  getCases = (data) => {
    this.setState({
      display_main_loader: 'show_block z-index-1000 bg-white',
      vpCaseLoader: true,
      questionLoader: true,
    });
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getCFAMockCases', data).then((resp) => {
      if (resp.success) {
        if (resp.question && resp.question.length) {
          this.setState({
            casesData: resp.question,
            isLoading: false,
            isDataLoading: false,
            vpCaseLoader: false,
            questionLoader: false,
            display_main_loader: 'hide_block',
            //selected case
            selectedQuestionData: resp.question[this.props.params.caseOffset],
            //all questions of selected case
            questionsData:
              resp.question[this.props.params.caseOffset] &&
              resp.question[this.props.params.caseOffset].cfa2_cbt_questions
                ? resp.question[this.props.params.caseOffset].cfa2_cbt_questions
                : [],
            //1st question of selected case
            selectedCaseQuestionData:
              resp.question[this.props.params.caseOffset] &&
              resp.question[this.props.params.caseOffset].cfa2_cbt_questions &&
              resp.question[this.props.params.caseOffset].cfa2_cbt_questions[
                this.props.params.quesOffset
              ]
                ? resp.question[this.props.params.caseOffset].cfa2_cbt_questions[
                    this.props.params.quesOffset
                  ]
                : [],
          });
        }
      } else {
        this.setState({
          isLoading: false,
          isDataLoading: false,
        });
      }
    });

    // getTotalQuestionsCount
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getTotalQuestionsCount', data).then(
      (resp) => {
        if (resp.success) {
          // console.log('Success --------> ', resp);
          this.setState({
            totalQuestionCount: resp.question,
          });
        } else {
          // console.log('falure --------> ', resp);
        }
      },
    );
  };

  changeCase = (questionNumber, index) => {
    const { casesData } = this.state;
    this.getUserStats();
    // this.getFlagQuestions();
    this.setState({
      isLoading: true,
    });
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
    };
    if (questionNumber) {
      //  '/cfa2cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer'
      let path = AppRoutes.CFA2_CBT_QUESTIONS_FINISH.replace(':id', this.props.params.id)
        .replace(':caseno', questionNumber)
        .replace(
          ':questiono',
          casesData[parseInt(this.props.params.caseOffset)] &&
            casesData[parseInt(this.props.params.caseOffset)].cfa2_cbt_questions[0]
            ? casesData[parseInt(this.props.params.caseOffset)].cfa2_cbt_questions[0].id
            : 1,
        )
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', index)
        .replace(':quesOffset', 0)
        .replace(':timer', this.props.params.timer);
      this.context.router.push(
        {
          pathname: path,
        },
        this.getCases(data),
      );
    }
  };

  getUserStats = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getUsersStats', data).then((resp) => {
      if (resp.success) {
        this.setState({
          userStatsData: resp.data,
          seconds: resp.data.user_time_value
            ? resp.data.user_time_value
            : parseInt(this.props.params.timer),
          isNegative: resp.data.isNegative,
        });

        attemptedCaseArray =
          resp.data.attemptedCases != null ? JSON.parse(resp.data.attemptedCases) : [];
      } else {
        this.setState({
          isLoading: false,
        });
      }
    });
  };
  changeQuestion = (questionNumber, index) => {
    this.setState({ report_block: 'card hide_block', successAlert: false });
    this.getUserStats();
    if (questionNumber) {
      // /cfa2cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset

      let path = AppRoutes.CFA2_CBT_QUESTIONS_FINISH.replace(':id', this.props.params.id)
        .replace(':caseno', this.props.params.caseno)
        .replace(':questiono', questionNumber)
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', this.props.params.caseOffset)
        .replace(':quesOffset', index)
        .replace(':timer', this.props.params.timer);
      this.context.router.push({
        pathname: path,
      });
    }
  };

  getNextCase = () => {
    const { casesData } = this.state;
    this.setState({
      isLoading: true,
    });
    this.slider.slickGoTo(3);

    let path = AppRoutes.CFA2_CBT_QUESTIONS_FINISH.replace(':id', this.props.params.id)
      .replace(
        ':caseno',
        this.props.params.caseOffset ? casesData[parseInt(this.props.params.caseOffset) + 1].id : 1,
      )
      .replace(
        ':questiono',
        casesData[parseInt(this.props.params.caseOffset) + 1] &&
          casesData[parseInt(this.props.params.caseOffset) + 1].cfa2_cbt_questions[0]
          ? casesData[parseInt(this.props.params.caseOffset) + 1].cfa2_cbt_questions[0].id
          : 1,
      )
      .replace(':testid', this.props.params.testid)
      .replace(
        ':caseOffset',
        this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) + 1 : 1,
      )
      .replace(':quesOffset', 0)
      .replace(':timer', this.props.params.timer);

    this.context.router.push({
      pathname: path,
    });
  };

  getPreviousCase = () => {
    const { casesData } = this.state;
    this.setState({
      isLoading: true,
    });
    this.slider.slickGoTo(3 - 2);

    let path = AppRoutes.CFA2_CBT_QUESTIONS_FINISH.replace(':id', this.props.params.id)
      .replace(
        ':caseno',
        this.props.params.caseOffset ? casesData[parseInt(this.props.params.caseOffset) - 1].id : 1,
      )
      .replace(
        ':questiono',
        casesData[parseInt(this.props.params.caseOffset) - 1] &&
          casesData[parseInt(this.props.params.caseOffset) - 1].cfa2_cbt_questions[0]
          ? casesData[parseInt(this.props.params.caseOffset) - 1].cfa2_cbt_questions[0].id
          : 1,
      )
      .replace(':testid', this.props.params.testid)
      .replace(
        ':caseOffset',
        this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) - 1 : 1,
      )
      .replace(':quesOffset', 0)
      .replace(':timer', this.props.params.timer);
    this.context.router.push({
      pathname: path,
    });
  };

  getPreviousQuestion = (index) => {
    const { questionsData } = this.state;

    let path = AppRoutes.CFA2_CBT_QUESTIONS_FINISH.replace(':id', this.props.params.id)
      .replace(':caseno', this.props.params.caseOffset)
      .replace(
        ':questiono',
        this.props.params.quesOffset
          ? questionsData[parseInt(this.props.params.quesOffset) - 1].id
          : 1,
      )
      .replace(':testid', this.props.params.testid)
      .replace(':caseOffset', this.props.params.caseOffset)
      .replace(
        ':quesOffset',
        this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) - 1 : 1,
      )
      .replace(':timer', this.props.params.timer);
    this.context.router.push({
      pathname: path,
    });
  };

  getNextQuestion = (index) => {
    const { questionsData } = this.state;

    let path = AppRoutes.CFA2_CBT_QUESTIONS_FINISH.replace(':id', this.props.params.id)
      .replace(':caseno', this.props.params.caseOffset)
      .replace(
        ':questiono',
        this.props.params.quesOffset
          ? questionsData[parseInt(this.props.params.quesOffset) + 1].id
          : 1,
      )
      .replace(':testid', this.props.params.testid)
      .replace(':caseOffset', this.props.params.caseOffset)
      .replace(
        ':quesOffset',
        this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) + 1 : 1,
      )
      .replace(':timer', this.props.params.timer);
    this.context.router.push({
      pathname: path,
    });
  };

  addHighlight = async (text) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const { selectedQuestionData } = this.state;

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: selectedQuestionData.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      type: 'highlight',
      text: text,
    };
    await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/addHighlightedText', data).then(
      async (res) => {
        this.setState({ showPopover: false });
        await this.getHighlightedText();
        clearSelection();
      },
    );
  };

  deleteHighlight = async (id) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: id,
    };

    if (id) {
      await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/deleteHighlightedText', data).then(
        async (res) => {
          this.setState({ showPopover: false });
          await this.getHighlightedText();
          clearSelection();
        },
      );
    } else {
      return;
    }
  };

  getHighlightedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getHighlightedText', data).then(
      async (res) => {
        this.setState({
          highlights: res.questions,
        });
      },
    );
  };

  getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    //console.log('userAgent', userAgent);
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  };

  clickOption = async (choice, questionId, selectedQuestionData, e) => {
    //console.log('e. type ___________', e.type);
    e.preventDefault();
    // on left click
    if (e.type === 'click') {
      //console.log('Left click');
      // console.log('Print params ---------> ', this.props.params);
      const userData = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        choice: choice,
        questionId: questionId,
        id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
        offset: this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) : null,
        caseno: this.props.params.caseno ? parseInt(this.props.params.caseno) : null,
        caseOffset: this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : null,
      };
      this.updateSelectedChoice(userData, selectedQuestionData, choice);
    } else if (e.type === 'contextmenu') {
      //console.log('Right click');
      //on right click
      this.addStrikeThrough(choice);
    }
  };

  addStrikeThrough = async (choice) => {
    //console.log('inside call apiiiii', choice);
    const { selectedQuestionData } = this.state;
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: selectedQuestionData.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      choice: choice,
    };

    await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/addStrikeThrough', data).then(
      async (res) => {
        //console.log('resssssssssssssssss', res);
        // this.setState({ showPopover: false });
        await this.getStrikedText();
        // clearSelection();
      },
    );
    // };
  };

  updateSelectedChoice = (userData, selectedQuestionData, choice) => {
    // console.log('userData --------------> ', userData);
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUsersChoice', userData).then(
      async (res) => {
        if (res.success) {
          const ansData = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            question_id: selectedQuestionData.id,
            answer:
              selectedQuestionData && selectedQuestionData.answer === choice
                ? 'correct'
                : 'incorrect',
            test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
            reading_id: selectedQuestionData.chapter_id,
          };
          this.getUserStats();
          FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUserAnswer', ansData).then(
            async (res) => {},
          );
        }
      },
    );
  };

  countDown() {
    const { runDecrement } = this.state;
    let seconds;
    if (this.state.seconds != 0 && runDecrement && this.state.isNegative === 'true') {
      seconds = this.state.seconds - 1;
    } else {
      seconds = this.state.seconds + 1;
      // '/cfa2cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart';
      let path = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
        .replace(':caseno', this.props.params.caseno)
        .replace(':questiono', this.props.params.questiono)
        .replace(':timer', this.props.params.timer)
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', this.props.params.caseOffset)
        .replace(':quesOffset', this.props.params.quesOffset)
        .replace(':isNegative', false)
        .replace(':timerStart', this.props.params.timerStart);
      this.context.router.push({
        pathname: path,
      });
      this.setState({
        runDecrement: false,
      });
    }
    this.setState({
      seconds: seconds,
    });

    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      timer: seconds,
      isNegative: this.state.isNegative,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUserTimer', data).then(
      async (res) => {
        if (res.success) {
        }
      },
    );
  }

  getrightanswer = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const ansdata = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getrightAnswer', ansdata).then(
      (resp_count) => {
        // console.log('I am on respnsod of right answer -----> ', resp_count);
        if (resp_count.success) {
          this.setState({
            rightanswercount: resp_count.allrightanswercount.question_count,
          });
        } else {
          // console.log(resp_count.success + '------------failure');
        }
      },
    );
  };
  handleScroll = () => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: 'smooth',
    });
  };

  changeFilter = (e, type) => {
    const { target } = e;
    const { checked } = target;
    const { filter } = this.state;
    if (checked) {
      let temp = [...filter];
      temp.push(type);
      this.setState({
        filter: temp,
      });
    } else {
      // to uncheck elements
      let prevArray = filter.filter((item) => item !== type);
      this.setState({
        filter: prevArray,
      });
    }
  };

  finishTest = () => {
    const { flag, userStatsData, questionsData } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    if (flag && flag.length) {
      this.setState({
        showFlaggedPopup: true,
      });
    } else if (Object.keys(userChoice).length !== questionsData.length) {
      this.setState({
        showNonAttemptedPopup: true,
      });
    } else {
      this.setState({ showFinishTestPopup: true });
    }

    //api to update status of quiz
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      status: 'completed',
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUserQuizStatus', data).then(
      async (res) => {
        if (res.success) {
        }
      },
    );
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }
  addHighlightToText = () => {
    let text = this.getSelectionHtml();
    this.addHighlight(text);
  };

  deleteHighlightFromText = () => {
    let text = this.getSelectionHtml();

    const { highlights } = this.state;
    let getHighlightedTextData = highlights
      ? highlights.filter((item) => {
          return item.text === text;
        })[0]
      : [];

    this.deleteHighlight(getHighlightedTextData.id);
  };

  getStrikedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getStrikedText', data).then(
      async (res) => {
        if (res && res.questions) {
          this.setState({
            strikeThroughArr: JSON.parse(res.questions.choiceArray),
          });
        } else {
          this.setState({
            strikeThroughArr: [],
          });
        }
      },
    );
  };

  getSelectionHtml = () => {
    var html = '';
    if (typeof window.getSelection != 'undefined') {
      var sel = window.getSelection();
      //console.log('heyyyyyyyyyyyyyyyy', sel);
      if (sel.rangeCount) {
        var container = document.createElement('div');
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        html = container.innerHTML;
      }
    } else if (typeof document.selection != 'undefined') {
      if (document.selection.type == 'Text') {
        html = document.selection.createRange().htmlText;
      }
    }
    return html;
  };

  // for IOS
  onTouchStart = (e, choice) => {
    e.preventDefault();
    // console.log(' window.navigator', window.navigator);
    const data = this.getMobileOperatingSystem();
    //console.log('datadata', data);
    if (data === 'Android') {
      return;
    } else {
      this.longPressCountdown = setTimeout(() => {
        //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
        this.addStrikeThrough(choice);
      }, longPressDuration);
    }
  };

  onTouchMove = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchCancel = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchEnd = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  backToMock = () => {
    let path = AppRoutes.CFA2_CBT_VIEW_ATTEMPTED_MOCK.replace(':id', this.props.params.id).replace(
      ':timer',
      this.props.params.timer,
    );
    this.context.router.push({
      pathname: path,
    });
  };
  getReadingViseScore = () => {
    // console.log('heeyyyyyyy');
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getrightAnswerReadingVise', data).then(
      async (res) => {
        // console.log('response of rightanswer ------> ', res);
        let temp = 0;
        let arr = res.readingName.map((item, i) => {
          if (res.allrightanswercount.some((ele) => ele.id === item.id)) {
            return Object.assign({}, item, res.allrightanswercount[temp++]);
          } else return Object.assign({}, item, 0);
        });
        this.setState({
          readingViseScore: arr,
        });
      },
    );
  };

  _hideReportForm = () => {
    document.getElementById('comment').value = '';
    this.setState({ report_block: 'card hide_block', reportError: '' });
  };

  reportQuestion = (id) => {
    var comment = document.getElementById('comment').value;

    this.setState({
      reportError: '',
    });
    if (comment.length < 2) {
      this.setState({
        reportError: 'Please enter comment',
      });
      return;
    }
    // BUG FIX: `questiono` is a URL position param (1-based question index
    // within a case), NOT the cfa2_cbt_questions primary key. Saving it as
    // `question_id` broke the admin auto-reply join (cfa2_cbt_question came
    // back null → empty reported_item). Sibling save/answer calls in this
    // file (~lines 402/510/535) already use selectedQuestionData.id /
    // selectedCaseQuestionData.id — reuse the same pattern here.
    const { selectedCaseQuestionData, selectedQuestionData } = this.state;
    const realQuestionId =
      (selectedCaseQuestionData && selectedCaseQuestionData.id) ||
      (selectedQuestionData && selectedQuestionData.id) ||
      (this.props.params.questiono ? parseInt(this.props.params.questiono) : null);

    var data = {
      case_id: this.props.params.caseno ? parseInt(this.props.params.caseno) : null,
      token: this.state.token,
      idname: this.state.idname,
      question_id: realQuestionId,
      comment: comment,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : 0,
      timer: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : 0,
      mockName: this.state.mockName,
      quesOffset: this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) : 0,
      caseOffset: this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 0,
    };

    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/reportQuestion', data).then((resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };
  render() {
    const {
      isLoading,
      questionsData,
      showFinishTestPopup,
      userStatsData,
      mockName,
      flag,
      showSectionReview,
      showNonAttemptedPopup,
      showFlaggedPopup,
      filter,
      selectedQuestionData,
      isDataLoading,
      seconds,
      timerStart,
      highlights,
      strikeThroughArr,
      casesData,
      vpCaseLoader,
      questionLoader,
      rightanswercount,
      outOfScore,
      selectedCaseQuestionData,
      readingViseScore,
      reportError,
      reportLoading,
      totalQuestionCount: questionCount,
    } = this.state;
    const { question_ids } = userStatsData
    const totalQuestionCount = (question_ids && JSON.parse(question_ids).length) || (questionCount && questionCount.length) || 0;
    let userTime = 0;
    if (userStatsData && userStatsData.user_time_value && this.props.params.timer) {
      if (userStatsData.isNegative === 'true') {
        userTime = SecondsToHHMMSS(
          parseInt(this.props.params.timer) - userStatsData.user_time_value,
        );
      } else {
        userTime = SecondsToHHMMSS(
          parseInt(this.props.params.timer) + userStatsData.user_time_value,
        );
      }
    }
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    const formatTimeF = SecondsToHHMMSS(seconds);
    let flaggedQuestion = flag.filter(
      (flag) => flag.question_id === selectedCaseQuestionData.id,
    )[0];
    const sliderSettings = questionsettings(
      this.props.params.offset ? parseInt(this.props.params.offset) : 1,
    );
    const topSliderSettings = caseCV(
      this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1,
    );
    var parseResult = Object.keys(userChoice).map(function (x) {
      return parseInt(x, 10);
    });
    selectedQuestionData.cfa2_cbt_questions;
    let count = 0;
    parseResult.forEach((element) => {
      let attemptedCount = questionsData.filter((item) => {
        if (item.id === element) {
          count++;
        }
        return item.id === element;
      });
    });

    let content = selectedQuestionData.question;
    if (highlights) {
      highlights.forEach((element) => {
        content = highlightString(content, element.text);
      });
    }
    let text = this.getSelectionHtml();
    let highlighted = `<b style="background-color: yellow" title="highlighted">${text}</b>`;
    let getHighlightedText = content ? content.indexOf(highlighted) : null;
    return (
      <div>
        <div className='animated fadeIn'>
          {isLoading ? (
            <Loader />
          ) : (
            <div
              className={
                casesData
                  ? casesData.length < 15
                    ? 'margin_bottom_20 ques-title-wrapper pl-0'
                    : 'margin_bottom_20 ques-title-wrapper'
                  : null
              }
            >
              <h1 className='section_head'> {mockName}</h1>
              <div className='finish-btn-wrapper'>
                <Button
                  className='pointer_class btn-primary back-btn'
                  onClick={() => this.backToMock()}
                >
                  {language.LC().BACK}
                </Button>
              </div>
            </div>
          )}
          {isLoading ? (
            <Loader />
          ) : casesData && casesData.length ? (
            <div>
              <div className='row'>
                <div className='col-md-12'>
                  {/* {console.log('casesData.length --------> ', casesData.length)} */}
                  <div
                    className={
                      casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
                    }
                  >
                    <Slider
                      {...topSliderSettings}
                      ref={(slider) => {
                        this.slider = slider;
                      }}
                    >
                      {/* {console.log(this.props.params)} */}
                      {casesData.map((item, index) => {
                        return (
                          <button
                            key={index}
                            onClick={() => this.changeCase(item.id, index)}
                            className={`${
                              attemptedCaseArray.indexOf(item.id) === -1
                                ? 'bg-completed-cases '
                                : ''
                            }
                              ${
                                index === parseInt(this.props.params.caseOffset)
                                  ? 'active button-trial'
                                  : 'button-trial'
                              }`}
                          >
                            {index + 1}
                          </button>
                        );
                      })}
                    </Slider>
                  </div>
                </div>
                <div className='case-detail-wrapper  col-md-12'>
                  <div className='card'>
                    <div className='card-header d-flex justify-content-between qus-header'>
                      {selectedQuestionData && selectedQuestionData.case ? (
                        <div className='ques-wrapper all-ques'>
                          <h1
                            className='text-center mb-2 text-capitalize'
                            dangerouslySetInnerHTML={{
                              __html: selectedQuestionData.case_name,
                            }}
                          />
                          <div
                            contentEditable='false'
                            className='font-weight-normal'
                            dangerouslySetInnerHTML={{
                              __html: selectedQuestionData.case,
                            }}
                          />
                        </div>
                      ) : null}
                      <div className='text-right que-action-arrow'>
                        <i
                          className={
                            this.props.params.caseOffset === '0'
                              ? `fa fa-angle-left ques_arrow pointer_class hide_block`
                              : `fa fa-angle-left ques_arrow pointer_class`
                          }
                          onClick={this.getPreviousCase}
                        />
                        <i
                          className={
                            parseInt(this.props.params.caseOffset) === casesData.length - 1
                              ? `fa fa-angle-right ques_arrow pointer_class hide_block`
                              : `fa fa-angle-right ques_arrow pointer_class`
                          }
                          onClick={this.getNextCase}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------- Questions with answers ---------------- */}
              <div className='row margin_bottom_20'>
                <div className='qus-tab-wrapper height-0'>
                  <Slider
                    {...sliderSettings}
                    ref={(slider) => {
                      this.slider = slider;
                    }}
                  >
                    {' '}
                    {questionsData.map((item, index) => {
                      let flaggedQuestions =
                        flag && flag.length
                          ? flag.filter((flag) => flag.question_id === item.id)[0]
                          : '';
                      return (
                        <div className='slide-button' key={index}>
                          <Button
                            key={index}
                            onClick={() => this.changeQuestion(item.id, index)}
                            className={`
                        ${index === parseInt(this.props.params.quesOffset) ? 'active' : ''}
                        ${
                          userChoice[item.id] === item.answer
                            ? 'right-ans'
                            : userChoice[item.id]
                              ? 'wrong-ans'
                              : 'not-ans'
                        }
                        ${flaggedQuestions ? 'flag-add' : ''}
                        `}
                          >
                            {flaggedQuestions ? (
                              <img
                                width='70'
                                src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                alt='Question'
                              />
                            ) : (
                              ''
                            )}
                            {index + 1}
                          </Button>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
                <div className='ques-detail-wrapper col-md-11'>
                  {isDataLoading ? (
                    <Loader />
                  ) : (
                    <div className='card'>
                      <div className={'main_loader ' + this.state.display_main_loader}>
                        <div className='loader-mid'>
                          <div className='card-block-loader'>
                            <Loader />
                          </div>
                        </div>
                      </div>
                      <div className='card-header qus-header finish-question-wrapper'>
                        {selectedCaseQuestionData && selectedCaseQuestionData.question ? (
                          <div className='qus-wrapper ques-bold-remove d-block all-ques'>
                            <div>
                              <img
                                src={
                                  App_data.frontend_url +
                                  '/img/question_bank/question_icon_blue.svg'
                                }
                                className='margin_right_20'
                                alt=''
                                width='30'
                              />
                              Q.
                              {parseInt(this.props.params.quesOffset) + 1}
                            </div>
                            <div
                              contentEditable='false'
                              dangerouslySetInnerHTML={{
                                __html: selectedCaseQuestionData.question,
                              }}
                              className='qus-title w-100'
                              style={{
                                marginTop: '8px',
                              }}
                            />
                          </div>
                        ) : null}
                        <span className='tooltip_wrap'>
                          <button
                            className='btn btn-primary pointer_class mid-btn'
                            onClick={() => {
                              this.setState({
                                showSectionReview: true,
                              });
                              this.getReadingViseScore();
                            }}
                          >
                            {language.LC().SCORE}
                          </button>
                          <div className='tootip_box'>{language.LC().SHOW_MYSCORE}</div>
                        </span>

                        <span className='tooltip_wrap tooltip_wrap_margin'>
                          <button
                            disabled={
                              (rightanswercount ? rightanswercount : 0) === 0 ? true : false
                            }
                            className={
                              (rightanswercount ? rightanswercount : 0) === 0
                                ? 'cursor_not_Allowed btn btn-primary  mid-btn'
                                : 'btn btn-primary mid-btn'
                            }
                            onClick={() => this.getDetailedResultGraph(totalQuestionCount)}
                          >
                            {language.LC().GRAPH}
                          </button>

                          {rightanswercount ? (
                            rightanswercount === 0 ? null : (
                              <div className='tootip_box'>{language.LC().SHOW_GRAPH}</div>
                            )
                          ) : null}
                        </span>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-8 col-lg-9'>
                            <div className='row'>
                              {optionsArr.map((item, index) => {
                                return (
                                  <div className='col-sm-12' id={item} key={index}>
                                    <div
                                      className={`answer_box cursor-default ${
                                        userChoice
                                          ? selectedCaseQuestionData &&
                                            selectedCaseQuestionData.answer === item &&
                                            userChoice[this.props.params.questiono] === item
                                            ? `border-green`
                                            : selectedCaseQuestionData.answer === item
                                              ? 'border-green'
                                              : userChoice[this.props.params.questiono] === item
                                                ? 'border-red'
                                                : ''
                                          : ''
                                      }`}
                                    >
                                      <div className='answer_count highlight_choice'>
                                        {item === 'choice_a'
                                          ? language.LC().A
                                          : item === 'choice_b'
                                            ? language.LC().B
                                            : language.LC().C}
                                      </div>
                                      <p className={`ans_box_text`}>
                                        {selectedCaseQuestionData &&
                                        selectedCaseQuestionData[item] ? (
                                          <span
                                            contentEditable='false'
                                            dangerouslySetInnerHTML={{
                                              __html: selectedCaseQuestionData[item],
                                            }}
                                          />
                                        ) : null}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className='col-sm-4 col-lg-3'>
                            <div className='score-wrapper'>
                              <div className='score-inner'>
                                {rightanswercount ? rightanswercount : 0}/{totalQuestionCount}
                              </div>
                              <h5>{language.LC().TOTAL_SCORE}</h5>
                              <h5>
                                {language.LC().You_Scored}{' '}
                                {Math.ceil(
                                  (rightanswercount ? rightanswercount * 100 : 0) /
                                    totalQuestionCount,
                                )}
                                %
                              </h5>
                            </div>
                            <div className='timer_outer finished-time'>
                              <div>
                                <h4>{language.LC().TEST_COMPLETED_IN}</h4>
                                <i className='fa fa-clock-o' />
                                <span className='timer_box'>{userTime}</span>
                              </div>
                            </div>
                          </div>

                          <div className='col-lg-12'>
                            <div className='text-right btm-btn-wrapper'>
                              <span
                                className='up tooltip-hover-questions'
                                style={{ padding: '10px' }}
                              >
                                <div className='tootip_box'>
                                  {' '}
                                  {language.LC().REPORT_THIS_QUESTION}{' '}
                                </div>
                                <div
                                  className='report-icon-wrapper'
                                  onClick={() => {
                                    this.handleScroll();
                                    this.setState({
                                      report_block: 'card show_block',
                                    });
                                  }}
                                >
                                  <img
                                    src={App_data.frontend_url + '/img/report4.png'}
                                    alt='report'
                                  />
                                </div>
                              </span>
                              <Button
                                onClick={() =>
                                  this.getPreviousQuestion(this.props.params.quesOffset)
                                }
                                className='pointer_class btn-primary'
                                disabled={parseInt(this.props.params.quesOffset) === 0}
                              >
                                <i className='fa fa-angle-left' /> {language.LC().BACK}
                              </Button>
                              <Button
                                onClick={() => this.getNextQuestion(this.props.params.quesOffset)}
                                className='pointer_class btn-primary'
                                disabled={
                                  parseInt(this.props.params.quesOffset) ===
                                  questionsData.length - 1
                                }
                              >
                                {language.LC().NEXT} <i className='fa fa-angle-right' />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* ------------------- Questions with answer ends------------- */}
              {/* -------------------- CORRECT INCORECT START---------------- */}
              <div className='card show_block'>
                <div className={'main_loader ' + this.state.display_main_loader}>
                  <div className='loader-mid'>
                    <div className='card-block-loader'>
                      <Loader />
                    </div>
                  </div>
                </div>
                <div
                  className={`card-header highlight_finish_text ${
                    userChoice &&
                    userChoice[this.props.params.questiono] === selectedCaseQuestionData.answer
                      ? 'text_success-cbt'
                      : !userChoice[this.props.params.questiono]
                        ? 'text_unAttempted-cbt'
                        : 'text_failure-cbt'
                  }`}
                >
                  {userChoice &&
                  userChoice[this.props.params.questiono] === selectedCaseQuestionData.answer
                    ? `${language.LC().Correct}`
                    : !userChoice[this.props.params.questiono]
                      ? `${language.LC().NOT_ATTEMPTED}`
                      : `${language.LC().Incorrect}`}
                </div>

                <div className='card-block'>
                  <p
                    className='answer_text'
                    dangerouslySetInnerHTML={{
                      __html:
                        selectedCaseQuestionData && selectedCaseQuestionData.answer
                          ? `${language.LC().THE_CORRECT_ANSWER_IS} ${
                              selectedCaseQuestionData.answer === 'choice_a'
                                ? `<strong>${language.LC().A}.</strong>`
                                : selectedCaseQuestionData.answer === 'choice_b'
                                  ? `<strong>${language.LC().B}.</strong>`
                                  : selectedCaseQuestionData.answer === 'choice_c'
                                    ? `<strong>${language.LC().C}.</strong>`
                                    : null
                            }`
                          : '',
                    }}
                  />
                  <p
                    contentEditable='false'
                    className='view_questionhtml'
                    dangerouslySetInnerHTML={{
                      __html:
                        selectedCaseQuestionData && selectedCaseQuestionData.explanation
                          ? selectedCaseQuestionData.explanation
                          : '',
                    }}
                  />
                </div>
              </div>

              {/* --------------------- CORRECT INCORRECT END --------------- */}
              {/* -------------------- Report section start ----------------- */}
              <div className='row'>
                <div className='col-md-12'>
                  <div className={this.state.report_block}>
                    <div className='card-header'>{language.LC().REPORT}</div>
                    {!this.state.successAlert ? (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong>{language.LC().COMMENT}</strong>
                            </label>
                          </div>
                          <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                            <textarea
                              id='comment'
                              name='comment'
                              rows='6'
                              className='form-control'
                              placeholder='Content..'
                            />
                          </div>
                          <div className='error_text ml-1'> {reportError}</div>
                        </div>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class report-btn'
                              disabled={reportLoading}
                              onClick={() => this.reportQuestion(selectedQuestionData.id)}
                            >
                              {reportLoading ? (
                                <span>
                                  <i className='fa fa-spinner fa-spin' />{' '}
                                  {language.LC().PLEASE_WAIT}
                                </span>
                              ) : (
                                language.LC().REPORT
                              )}
                            </button>
                            <button
                              type='button'
                              className='btn btn-danger active pointer_class margin_left_10'
                              onClick={() => this._hideReportForm()}
                            >
                              {language.LC().CANCEL}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={() => {
                                this.setState({
                                  report_block: 'card hide_block',
                                  successAlert: false,
                                });
                              }}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* -------------------- Report section End ------------------- */}
            </div>
          ) : (
            <div className='no-qus-found'>
              <img width='105px' src={App_data.frontend_url + '/img/questions/problem.png'} />
              <h3>{language.LC().NO_QUESTION_FOUND}</h3>
              <p> {language.LC().NO_QUESTION_FOR_THIS_EXAM}</p>
            </div>
          )}
        </div>
        {/* ========== For Score Side Bar S =============== */}

        <div
          className={`sidebar-review-wrapper sidebar-score-wrapper ${
            showSectionReview ? 'active' : ''
          }`}
        >
          <div className='header-review'>
            <h2> {language.LC().TOPIC_WISE_SCORE}</h2>
            <span
              className='cursor-pointer'
              onClick={() => {
                this.setState({
                  showSectionReview: false,
                });
              }}
            >
              <img width='30px' src={App_data.frontend_url + '/img/questions/icon_close.png'} />
            </span>
          </div>
          <div className='body-review'>
            <ul className='score-list-wrapper'>
              {readingViseScore && readingViseScore.length ? (
                readingViseScore.map((item, index) => {
                  let readingPercentage =
                    (item.question_count * 100) / item.cfa2_cbt_questions.length;
                  return (
                    <li key={index}>
                      <div>
                        <h4>
                          {index + 1}&nbsp; {item.chapter_name}
                        </h4>
                        <div className='progress custom-prog-bar margin_top_5'>
                          <div
                            className='progress-bar'
                            role='progressbar'
                            style={{
                              width: `${Math.ceil(readingPercentage)}%`,
                            }}
                            aria-valuenow={`${Math.ceil(readingPercentage)}`}
                            aria-valuemin='0'
                            aria-valuemax='100'
                          >
                            {Math.ceil(readingPercentage) ? Math.ceil(readingPercentage) : 0}%
                          </div>
                        </div>
                      </div>
                      <p className='score-inner'>
                        {item.question_count ? item.question_count : 0}/
                        {item.cfa2_cbt_questions ? item.cfa2_cbt_questions.length : 0}
                      </p>
                    </li>
                  );
                })
              ) : (
                <div className='no-qus-found no-mock-exam mt-5'>
                  <img
                    width='62px'
                    src={App_data.frontend_url + '/img/questions/icon_nomock.png'}
                  />
                  <h3 className='mt-1'>{language.LC().NO_SCORE_FOUND}</h3>
                </div>
              )}
            </ul>
          </div>
        </div>
        {/* =========For Score Side Bar E============ */}
        <CBTFinishTest
          showFinishTestPopup={showFinishTestPopup}
          submitTest={() => this.submitTest()}
          handleClose={() => this.setState({ showFinishTestPopup: false })}
        />
        <CBTNonAttempted
          showFinishTestPopup={showNonAttemptedPopup}
          submitTest={() =>
            this.setState({
              showFinishTestPopup: true,
              showNonAttemptedPopup: false,
            })
          }
          handleClose={() => this.setState({ showNonAttemptedPopup: false })}
        />
        <CBTFlagged
          showFinishTestPopup={showFlaggedPopup}
          submitTest={() =>
            this.setState({
              showFlaggedPopup: false,
              showFinishTestPopup: true,
            })
          }
          handleClose={() => this.setState({ showFlaggedPopup: false })}
        />
      </div>
    );
  }
}

export default CFAQuestions;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA2CBTNew/FinishTest/index.js